import { Position } from "@xyflow/react";
import { v4 as UUIDv4 } from "uuid";

// Flow diagram layout constants
export const COLUMN_SPACING = 400;
export const ROW_SPACING = 200;
export const DIVIDER_X = 350; // Position divider between stakeholder and goal

export const segmentNodeStyle = {
  sourcePosition: Position.Right,
  targetPosition: Position.Left,
  style: {
    //   borderRadius: "16px",
    //   backgroundColor: "#fff",
    //   border: "1px solid #e5e7eb",
    minWidth: "300px",
    maxWidth: "300px",
    //   minHeight: "120px",
    //   display: "flex",
    //   flexDirection: "column",
    //   alignItems: "start",
    justifyContent: "center",
    //   padding: "0px",
  },
};

export function convertStakeholdersToFlowDiagram(stakeholderData) {
  // Convert nested structure to flow diagram nodes and edges
  // Flow: Stakeholder → Divider → Goal → Actions
  const nodes = [];
  const edges = [];

  let stakeholderY = 0;
  let totalHeight = 0;

  stakeholderData.forEach((stakeholder, stakeholderIndex) => {
    const stakeholderNodeId = `stakeholder-${stakeholder.id}`;

    // Calculate vertical center for stakeholder based on number of goals
    const triggersCount = stakeholder.triggers.length;
    const stakeholderCenterY =
      stakeholderY + ((triggersCount - 1) * ROW_SPACING) / 2;

    // 1️⃣ Create Stakeholder Node
    nodes.push({
      id: stakeholderNodeId,
      type: "stakeholder",
      position: {
        x: 0,
        y: stakeholderCenterY,
      },
      data: {
        title: stakeholder.title,
        description: `${triggersCount} goal${triggersCount !== 1 ? "s" : ""}`,
      },
      // ...segmentNodeStyle,
    });

    // 2️⃣ Create Goal Nodes
    stakeholder.triggers.forEach((trigger, triggerIndex) => {
      const triggerNodeId = `trigger-${trigger.id}`;
      const triggerY = stakeholderY + triggerIndex * ROW_SPACING;

      nodes.push({
        id: triggerNodeId,
        type: "trigger",
        position: {
          x: COLUMN_SPACING,
          y: triggerY,
        },
        data: {
          title: trigger.title,
          description: `${trigger.actions.length} action${trigger.actions.length !== 1 ? "s" : ""}`,
          actionSegments: trigger.actions.map((action) => ({
            id: action.id,
            type: action.type,
            delay: action.delay,
            outcomeGoal: action.outcomeGoal,
            sortIndex: action.sortIndex,
            data:
              action.type === "email"
                ? {
                    title: action.title,
                    emailSubject: action.emailSubject,
                  }
                : undefined,
          })),
        },
        ...segmentNodeStyle,
      });

      // Create edge from stakeholder to goal
      edges.push({
        type: "base",
        id: UUIDv4(),
        source: stakeholderNodeId,
        target: triggerNodeId,
        className: "flowing-dashed",
      });

      // 3️⃣ Create Action Nodes
      // Sort actions by sortIndex
      const sortedActions = [...trigger.actions].sort(
        (a, b) => a.sortIndex - b.sortIndex
      );

      console.log("sortedActions", sortedActions);

      let actionY = triggerY;
      sortedActions.forEach((action, actionIndex) => {
        const actionNodeId = `action-${action.id}`;

        nodes.push({
          id: actionNodeId,
          type: action.type,
          position: {
            x: COLUMN_SPACING * 2 + actionIndex * COLUMN_SPACING,
            y: triggerY,
          },
          data: {
            title: action.title || `${action.type} action`,
            description:
              action.type === "email"
                ? action.emailSubject
                : action.type === "delay"
                  ? `Wait ${action.delay} day${action.delay !== 1 ? "s" : ""}`
                  : action.type,
          },
          ...segmentNodeStyle,
        });

        // Create edge from goal to first action only
        if (actionIndex === 0) {
          edges.push({
            type: "base",
            id: UUIDv4(),
            source: triggerNodeId,
            target: actionNodeId,
            className: "flowing-dashed",
          });
        }

        // For sequential actions, connect action to next action
        if (actionIndex < sortedActions.length - 1) {
          const nextActionNodeId = `action-${sortedActions[actionIndex + 1].id}`;
          edges.push({
            type: "base",
            id: UUIDv4(),
            source: actionNodeId,
            target: nextActionNodeId,
            className: "flowing-dashed",
          });
        }

        actionY += 120; // Smaller spacing for actions within same goal
      });
    });

    // Update Y position for next stakeholder
    stakeholderY += triggersCount * ROW_SPACING + 100; // Add extra space between stakeholders
    totalHeight = stakeholderY; // Track total height
  });

  // Add vertical dividers at the beginning so they render behind other nodes
  nodes.unshift({
    id: "divider-vertical-1",
    type: "divider",
    position: {
      x: DIVIDER_X,
      y: -50, // Start a bit above the first node
    },
    data: {
      height: totalHeight + 100, // Extend below the last node
    },
    draggable: false,
    selectable: false,
    style: {
      zIndex: -1,
    },
  });

  nodes.unshift({
    id: "divider-vertical-2",
    type: "divider",
    position: {
      x: 750,
      y: -50, // Start a bit above the first node
    },
    data: {
      height: totalHeight + 100, // Extend below the last node
    },
    draggable: false,
    selectable: false,
    style: {
      zIndex: -1,
    },
  });

  console.log("Generated nodes:", nodes);
  console.log("Generated edges:", edges);

  return { nodes, edges };
}

